import React, { useState, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'antd';
import moment from 'moment';
import CurrencyInput from '../../../../../../CommonComponents/CurrencyInput/CurrencyInput';
import RecurringEditableCard from './RecurringEditableCard';
import EditableRecurringFooter from './Footer';
import { Wrapper } from './styles';
import {
  LinkWrapper,
  GrantNameField,
  DateSelector,
  AlertWrap,
} from '../../style';
import formatter from '../../../../../../utils/formatter';
import { CardContainer } from '../RenderCard/style';
import { statusChecker } from '../../utils';
import ErrorPopup from '../../../../../../CommonComponents/ErrorPopup/ErrorPopup';
import { CommonTable } from '../../../../../../CommonComponents/commonStyles';
import { checkCSRBusinessFunction } from '../../../../../../CSR/utils/CommonUtils';
import { BUSINESS_FUNCTION } from '../../../../../../CSR/utils/csrBusinessFunctionMapper';
import {
  AlertContent,
  Types,
} from '../../../../../../CommonComponents/ContentMessages';
import { recordError } from '../../../../../../utils/commonUtil';
import { CapsuleButton } from '../../../../../../CommonComponents/Commons/commonComponents';

const grantAmountRender = ({
  value,
  record,
  i,
  handleInputChange,
  handleInputBlur,
}) =>
  statusChecker(record.status) ? (
    <Wrapper Input>
      <CurrencyInput
        name="amount"
        id={`txtamount${i}`}
        label="grant-amount"
        aria-label="grant Amount"
        placeholder="Grant Amount"
        maxLength={150}
        onChange={(e) => handleInputChange(i, e)}
        value={value}
        onBlur={(e) => handleInputBlur(e, record, i)}
      />
    </Wrapper>
  ) : (
    <Wrapper Label>{formatter({ value, fieldSuffix: 'Dollars' })}</Wrapper>
  );

const scheduleDateRender = ({ value, record, i, dateChangeHandle }) =>
  value ? (
    statusChecker(record.status) ? (
      <DateSelector
        id={`txtdate${i}`}
        aria-label="date"
        name="date"
        format="MM/DD/YYYY"
        onChange={(e, date) => dateChangeHandle(e, date, i)}
        value={value ? moment(value) : null}
      />
    ) : (
      <Wrapper Label>{value}</Wrapper>
    )
  ) : (
    <div>&mdash;</div>
  );

// Check the feature is available by the particular csr user
const checkCsrBusiness = (businessFunction, csrBusinessFunction) => {
  return checkCSRBusinessFunction(
    BUSINESS_FUNCTION[businessFunction],
    csrBusinessFunction
  );
};

const RecurringEditableTable = (props) => {
  const {
    spawns,
    cancelApi,
    editedSpawns,
    addGrandHandler,
    handleInputChange,
    individualResetHandler,
    handleInputBlur,
    dateChangeHandle,
    csrBusinessFunction,
  } = props;
  const warningContents = {
    allSpawns: 'Are you sure you want to cancel all remaining payments?',
    spawn: 'Are you sure you want to cancel this grant payment?',
    reset: 'Resetting will clear all entered information on the page',
    add:
      'The grant payment added to the schedule will follow details of the previous payment in the schedule.',
  };
  const [contentType, setPopUpContent] = useState(false);
  const [_currentSpawnId, setCurrentSpawn] = useState(false);
  const [_currentSpawnStatus, setSpawnStatus] = useState(false);
  const [spawnsCollection, setSpawnCollection] = useState(spawns);
  const [cancelPopUp, setCancelPopup] = useState(false);
  const [resetPopUp, setResetPopUp] = useState(false);
  const [addGrantPopUp, setAddGrantPopUp] = useState(false);
  const [resetIndex, setResetIndex] = useState();
  const [resetData, setResetData] = useState();

  useEffect(() => {
    setSpawnCollection(spawns);
  }, [spawns]);

  const individualCancelHandler = useCallback(
    (record, type) => {
      try {
        if (record) {
          let _spawnId = record && record.spawnId;
          let _spawnStatus = record && record.status;
          setCurrentSpawn(_spawnId);
          setSpawnStatus(_spawnStatus);
        }
        if (type) {
          setPopUpContent(type);
        } else {
          setCurrentSpawn(false);
          setPopUpContent('allSpawns');
        }
        setCancelPopup(!cancelPopUp);
      } catch (error) {
        recordError(error);
      }
    },
    [spawns]
  );

  const addGrantApiCallPopup = () => setAddGrantPopUp(true);

  const resetHandler = useCallback(
    (record, index) => {
      try {
        setResetIndex(index);
        setPopUpContent('reset');
        setResetData(record);
        setResetPopUp(true);
      } catch (error) {
        recordError(error);
      }
    },
    [spawns]
  );

  const grandTotal = (grants) =>
    grants && grants.reduce((a, b) => a + parseFloat(b.amount), 0); 

  const columnConfig = [
    {
      title: 'Grant Name',
      dataIndex: 'grantName',
      key: 'grantName',
      render: (value) => <GrantNameField>{value}</GrantNameField>,
    },
    {
      title: 'Grant Amount',
      dataIndex: 'amount',
      key: 'amount',
      render: (value, record, i) =>
        grantAmountRender({
          value,
          record,
          i,
          handleInputChange,
          handleInputBlur,
        }),
    },
    {
      title: 'Scheduled Issue Date',
      dataIndex: 'scheduledDate',
      key: 'scheduledDate',
      render: (value, record, i) =>
        scheduleDateRender({ value, record, i, dateChangeHandle }),
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      render: (value) =>
        value ? (
          <GrantNameField NoBorder>{value}</GrantNameField>
        ) : (
          <div>&mdash;</div>
        ),
    },
    {
      title: 'Issue Date',
      dataIndex: 'issueDate',
      key: 'issueDate',
      render: (value) =>
        value ? <GrantNameField NoBorder>{value}</GrantNameField> : '',
    },
    {
      title: '',
      dataIndex: 'status',
      key: 'status',
      render: (value, record, index) =>
        editedSpawns && editedSpawns.includes(record.spawnId) ? (
          <LinkWrapper tableFont onClick={() => resetHandler(record, index)}>
            Reset
          </LinkWrapper>
        ) : statusChecker(record.status) ? (
          <LinkWrapper
            tableFont
            onClick={() => individualCancelHandler(record, 'spawn')}
            className={
              checkCsrBusiness(
                'DONOR_PORTAL_EDIT_RECURRING_GRANT_SCHEDULE_FULL_ACCESS',
                csrBusinessFunction
              )
                ? 'disable-link-click'
                : ''
            }
          >
            Cancel
          </LinkWrapper>
        ) : (
          ''
        ),
    },
  ];

  return (
    <>
      <>
        <ErrorPopup
          title={
            <AlertContent
              page={'Edit Grant'}
              type={[Types.PAGE_ALERTS]}
              keyProperty={'Reset Edit Grant'}
              property={'field_header'}
              html={true}
              defaultMessage={'Reset'}
            />
          }
          show={resetPopUp}
          primaryCta={() => {
            setResetPopUp(false);
            individualResetHandler(resetData, resetIndex);
          }}
          secondaryCta={() => setResetPopUp(false)}
          secondaryCtaLabel={
            <AlertContent
              page={'Edit Grant'}
              type={[Types.PAGE_ALERTS]}
              keyProperty={'Reset Edit Grant'}
              property={'field_alert_button2_text'}
              html={true}
              defaultMessage={'No, take me back'}
            />
          }
          primaryCtaLabel={
            <AlertContent
              page={'Edit Grant'}
              type={[Types.PAGE_ALERTS]}
              keyProperty={'Reset Edit Grant'}
              property={'field_alert_button1_text'}
              html={true}
              defaultMessage={'Continue'}
            />
          }
        >
          <AlertWrap>
            <AlertContent
              page={'Edit Grant'}
              type={[Types.PAGE_ALERTS]}
              keyProperty={'Reset Edit Grant'}
              property={'field_description'}
              html={true}
              defaultMessage={warningContents[contentType]}
            />
          </AlertWrap>
        </ErrorPopup>
      </>
      <>
        <ErrorPopup
          title={
            <AlertContent
              page={'Edit Grant'}
              type={[Types.PAGE_ALERTS]}
              keyProperty={
                contentType === 'allSpawns'
                  ? 'Cancel All Payment Edit Grant'
                  : 'Cancel Payment Edit Grant'
              }
              property={'field_header'}
              html={true}
              defaultMessage={'Cancel'}
            />
          }
          show={cancelPopUp}
          primaryCtaLabel={
            <AlertContent
              page={'Edit Grant'}
              type={[Types.PAGE_ALERTS]}
              keyProperty={
                contentType === 'allSpawns'
                  ? 'Cancel All Payment Edit Grant'
                  : 'Cancel Payment Edit Grant'
              }
              property={'field_alert_button1_text'}
              html={true}
              defaultMessage={'CONTINUE'}
            />
          }
          primaryCta={() => {
            setCancelPopup(false);
            _currentSpawnId
              ? cancelApi(_currentSpawnId, 'single', _currentSpawnStatus)
              : cancelApi(_currentSpawnId, 'all');
          }}
          secondaryCta={() => individualCancelHandler()}
          secondaryCtaLabel={
            <AlertContent
              page={'Edit Grant'}
              type={[Types.PAGE_ALERTS]}
              keyProperty={
                contentType === 'allSpawns'
                  ? 'Cancel All Payment Edit Grant'
                  : 'Cancel Payment Edit Grant'
              }
              property={'field_alert_button2_text'}
              html={true}
              defaultMessage={'No, take me back'}
            />
          }
        >
          <AlertWrap>
            <AlertContent
              page={'Edit Grant'}
              type={[Types.PAGE_ALERTS]}
              keyProperty={
                contentType === 'allSpawns'
                  ? 'Cancel All Payment Edit Grant'
                  : 'Cancel Payment Edit Grant'
              }
              property={'field_description'}
              html={true}
              defaultMessage={warningContents[contentType]}
            />
          </AlertWrap>
        </ErrorPopup>
      </>
      <>
        <ErrorPopup
          title={
            <AlertContent
              page={'Edit Grant'}
              type={[Types.PAGE_ALERTS]}
              keyProperty={'Add Grant'}
              property={'field_header'}
              html={true}
              defaultMessage={'Add Grant'}
            />
          }
          show={addGrantPopUp}
          primaryCta={() => {
            setAddGrantPopUp(false);
            addGrandHandler();
          }}
          primaryCtaLabel={
            <AlertContent
              page={'Edit Grant'}
              type={[Types.PAGE_ALERTS]}
              keyProperty={'Add Grant'}
              property={'field_alert_button1_text'}
              html={true}
              defaultMessage={'Ok'}
            />
          }
        >
          <AlertWrap>
            <AlertContent
              page={'Edit Grant'}
              type={[Types.PAGE_ALERTS]}
              keyProperty={'Add Grant'}
              property={'field_description'}
              html={true}
              defaultMessage={warningContents['add']}
            />
          </AlertWrap>
        </ErrorPopup>
      </>
      <Row>
        <Col lg={24} md={24} sm={0} xs={0}>
          <CommonTable
            dataSource={spawnsCollection}
            columns={columnConfig}
            pagination={false}
          />
        </Col>
      </Row>
      <Row>
        <Col lg={0} md={0} sm={24} xs={24}>
          {spawnsCollection &&
            spawnsCollection.map((data, index) => (
              <CardContainer
                editableTable
                key={data.spawnId.toString()}
                index={index % 2}
              >
                <RecurringEditableCard
                  data={data}
                  index={index}
                  editedSpawns={editedSpawns}
                  resetHandler={resetHandler}
                  handleInputBlur={handleInputBlur}
                  dateChangeHandle={dateChangeHandle}
                  handleInputChange={handleInputChange}
                  individualCancelHandler={individualCancelHandler}
                  component="RecurringEditableCard"
                />
              </CardContainer>
            ))}
        </Col>
      </Row>

      <EditableRecurringFooter
        addGrandHandler={addGrantApiCallPopup}
        csrBusinessFunction={csrBusinessFunction}
        totalAmount={formatter({
          value: grandTotal(spawnsCollection),
          fieldSuffix: 'Dollars',
        })}
      />
      <Wrapper PaddingTopBottom>
        {checkCSRBusinessFunction(
          BUSINESS_FUNCTION[
            'DONOR_PORTAL_EDIT_RECURRING_GRANT_SCHEDULE_FULL_ACCESS'
          ],
          csrBusinessFunction
        ) ? (
          <CapsuleButton
            text="Cancel All Remaining Payments" 
            disabled={true}
            iconType = 'binIcon' 
            id="btnCancelAllRemainingPayments1"
            alt = "add icon"
           />
        ) : (
          <CapsuleButton
            text="Cancel All Remaining Payments" 
            iconType = 'binIcon' 
            id="btnCancelAllRemainingPayments2"
            onClick={individualCancelHandler}
            alt = "add icon"
           />
        )}
      </Wrapper>
    </>
  );
};

RecurringEditableTable.propTypes = {
  addGrandHandler: PropTypes.func,
  cancelApi: PropTypes.func,
  csrBusinessFunction: PropTypes.any,
  dateChangeHandle: PropTypes.func,
  editedSpawns: PropTypes.array,
  grantsDetails: PropTypes.shape({
    frequency: PropTypes.string,
    grantAmount: PropTypes.string,
    grantName: PropTypes.string,
    noOfPayment: PropTypes.string,
    startDate: PropTypes.string,
  }),
  handleInputBlur: PropTypes.func,
  handleInputChange: PropTypes.func,
  individualResetHandler: PropTypes.func,
  spawns: PropTypes.arrayOf(
    PropTypes.shape({
      allocationType: PropTypes.string,
      amount: PropTypes.string,
      checkNumber: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      grantAllocation: PropTypes.array,
      grantName: PropTypes.string,
      issueDate: PropTypes.string,
      scheduledDate: PropTypes.string,
      spawnId: PropTypes.number,
      status: PropTypes.string,
    })
  ),
};

export default RecurringEditableTable;
